import { render, staticRenderFns } from "./CryptoWithdrawForm.vue?vue&type=template&id=55275bd3&scoped=true"
import script from "./CryptoWithdrawForm.vue?vue&type=script&lang=js"
export * from "./CryptoWithdrawForm.vue?vue&type=script&lang=js"
import style0 from "./CryptoWithdrawForm.vue?vue&type=style&index=0&id=55275bd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55275bd3",
  null
  
)

export default component.exports